module.exports = "<div id=\"referral-block\" class=\"container\">\n  <p class=\"tagline\">EARN MONEY FOR TABLE AND PACKAGE RESERVATIONS</p>\n  <p class=\"description\">Get ${{referralGiveCredit}} for every friend you invite.</p>\n  <p class=\"learn-more\"><a href=\"#\" ui-sref=\"appearnCredit\">Learn More</a></p>\n  <input ng-value=\"currentUser.referralCode\" class=\"referral-code\" />\n  <p class=\"lead-small\">We'll include a special referral link when you share Tablelist on Facebook or Twitter.</p>\n  <share-bar></share-bar>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/directives/referralBlock/template.html
// module id = 861
// module chunks = 1